import { LinkId } from '../../../../common/AnalyticsContext/LinkId';
import { useSearchFilters } from '../../../../common/components/SearchHeader/filters/useSearchFilters';
import { SPECIALTY_GENERAL_PRACTICE } from '../../../../common/components/SearchHeader/types/FilterChoice';
import { DropDownFilterPill } from '../../FilterPill/DropDownFilterPill';
import { useOverlay } from '../../overlay/OverlayContext';
import { SpecialtyFilterContent } from './SpecialtyFilterContent';

const TITLE = 'Specialty';

export const SpecialtyFilter = () => {
  const [filters, setFilters] = useSearchFilters();
  const { clear } = useOverlay();

  const handleChange = (specialist: string): void => {
    setFilters({
      ...filters,
      topic: { specialist },
      alwaysShowFilters: true,
    });

    clear();
  };

  const caption = filters.topic?.bulkBillingGp
    ? SPECIALTY_GENERAL_PRACTICE
    : filters.topic?.specialist ?? TITLE;

  const handleClear = () => setFilters({ ...filters, topic: undefined });

  return (
    <DropDownFilterPill
      hasValue={
        filters.topic?.specialist !== undefined || filters.topic?.bulkBillingGp !== undefined
      }
      fixedMobileHeight
      onClear={handleClear}
      caption={caption}
      trackingId={LinkId.FILTER_BY_SPECIALTY_BUTTON}
      content={<SpecialtyFilterContent onChange={handleChange} value={filters.topic?.specialist} />}
    />
  );
};
